export const PrivateBetaBadge = () => {
  return (
    <a
      href="https://form.typeform.com/to/eEmqHgKB"
      target="_blank"
      className="flex justify-center text-sm mt-6 items-center bg-bolt-ds-brand/10 border border-bolt-ds-brand/10 text-bolt-ds-brand py-2 px-3 rounded-md underline"
    >
      Sign up for Private Beta
    </a>
  );
};
